import { cn } from "@/core/helpers/cn";
import formatPrice from "@/core/helpers/formatPrice";
import { BankBullet } from "@/domains/bank/components/BankBullet/BankBullet";

export function BankBranchCardBalance({
  hideBalance,
  balance,
  className,
}: {
  hideBalance: boolean;
  balance: number;
  className?: string;
}) {
  const hiddenBalance = formatPrice(balance).replace(/\d/g, "*");

  return (
    <div className={cn("flex items-center gap-4", className)}>
      <div className="flex flex-col gap-1">
        <div className="relative text-18 text-white tabular-nums">
          {hideBalance ? hiddenBalance : formatPrice(balance)} ₽
        </div>

        <div className="text-11 font-bold text-sbank uppercase">Текущий баланс счета</div>
      </div>

      <BankBullet>₽</BankBullet>
    </div>
  );
}
